<template>
  <Transition
    enter-active-class="transition ease-out duration-300"
    enter-from-class="transform translate-y-full opacity-0"
    enter-to-class="transform translate-y-0 opacity-100"
    leave-active-class="transition ease-in duration-200"
    leave-from-class="transform translate-y-0 opacity-100"
    leave-to-class="transform translate-y-full opacity-0"
  >
    <div
      v-if="show"
      class="fixed bottom-0 left-0 right-0 z-50 bg-yellow-500 dark:bg-yellow-600 text-white shadow-lg"
    >
      <div class="max-w-7xl mx-auto px-4 py-3 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between flex-wrap">
          <div class="flex-1 flex items-center">
            <span class="flex p-2 rounded-lg bg-yellow-600 dark:bg-yellow-700">
              <svg class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
            </span>
            <p class="ml-3 font-medium truncate">
              <span class="md:hidden">Nová verze je k dispozici</span>
              <span class="hidden md:inline">
                Nová verze aplikace je k dispozici. Obnovte stránku pro načtení aktualizace.
              </span>
            </p>
          </div>
          <div class="flex-shrink-0 flex items-center space-x-2 mt-2 sm:mt-0">
            <button
              type="button"
              class="px-4 py-2 rounded-md text-sm font-medium bg-white text-yellow-600 hover:bg-yellow-50 focus:outline-none focus:ring-2 focus:ring-white transition-colors"
              @click="reload"
            >
              Obnovit nyní
            </button>
            <button
              type="button"
              class="p-2 rounded-md hover:bg-yellow-600 dark:hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-white transition-colors"
              @click="dismiss"
            >
              <span class="sr-only">Zavřít</span>
              <svg class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  (e: 'reload'): void
  (e: 'dismiss'): void
}>()

function reload() {
  emit('reload')
}

function dismiss() {
  emit('dismiss')
}
</script>
